// miliseconds
export default {
  SIDEBAR: 500,
  SIDEBARITEM: 400,
}
